import { forwardRef } from 'react';
import { Typography } from '../Typography/Typography.js';
import { getWrapperStyles, getTypographyStyles } from './OptionGroupStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const OptionGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    label,
    ...rest
  } = _ref;
  return jsxs("div", {
    role: "group",
    css: getWrapperStyles,
    ref: ref,
    ...rest,
    children: [jsx(Typography, {
      variant: "body2",
      bold: true,
      css: getTypographyStyles,
      children: label
    }), children]
  });
});
OptionGroup.displayName = 'OptionGroup';

export { OptionGroup };
//# sourceMappingURL=OptionGroup.js.map
